<template>
  <v-card
    :to="{name:'NovelIndexInFolder', params:{novelid:encodeHash(item.item.novelId), folderid:encodeHash(item.item.id)}}"
    class="d-flex flex-column"
    flat
    min-height="150px"
    style="border-radius: 8px"
  >
    <v-card-title class="pb-2 pt-3">
      <v-list-item
        class="ma-0 pa-0 "
        dense
        style="width: 100%;"
      >
        <DragHandle
          v-if="originalSort"
          class="item-handle mx-0 px-2"
        />
        <v-list-item-icon class="ma-0 mt-1 pa-0">
          <FolderIcon style="width: 22px;height: 27px" />
        </v-list-item-icon>
        <v-list-item-title class="ma-0 pa-0">
          <div
            v-if="user.pageFilterTitle"
            class="mx-4"
            style="font-size: 16px;font-weight: bold;opacity: 70%; text-overflow: ellipsis;overflow: hidden; white-space: nowrap;"
          >
            {{ item.item.name }}
          </div>
        </v-list-item-title>
        <v-list-item-action class="ma-0 pa-0">
          <v-icon
            v-if="checkedItems && checkedItems.indexOf(item)!=-1"
            color="secondary"
            @click.prevent="toggleItemCheck(item)"
          >
            mdi-checkbox-multiple-marked-circle
          </v-icon>
          <v-icon
            v-else
            color="textcolor"
            style="opacity: 0.7;"
            @click.prevent="toggleItemCheck(item)"
          >
            mdi-checkbox-multiple-marked-circle-outline
          </v-icon>
        </v-list-item-action>
      </v-list-item>
    </v-card-title>
    <div class="griditem-border mr-4 ml-4" />
    <v-card-text class="mx-1 my-0 py-2">
      <v-clamp
        :max-lines="1"
        autoresize
        class="pa-0 ma-0 "
        style="font-size: 12px;color: #797979;"
      >
        {{ item.item.content }}
      </v-clamp>
      <div
        v-if="user.pageFilterUpdate"
        class="d-flex align-center"
      >
        <ListIcon
          :style="`color: ${accentColor};width:6px;height:7px`"
          class="mr-1"
        />
        <div
          class="griditem-content-bold mr-3"
          style="padding-top:1px;"
        >
          最終更新日時
        </div>
        <div
          class="griditem-content"
          style="padding-top:1px;"
        >
          {{ item.item.updateDate |dayjs }}
        </div>
      </div>
    </v-card-text>
    <v-card-actions class="ma-0 pa-0">
      <v-spacer />
      <v-btn
        class="ma-0 mr-2"
        color="secondary"
        elevation="0"
        small
        tile
        @click.prevent="edit(item.item)"
      >
        編集
      </v-btn>
      <v-btn
        class="ma-0"
        color="secondary"
        elevation="0"
        small
        tile
        @click.prevent="folderSelectDialog=true"
      >
        フォルダ移動
      </v-btn>
      <v-btn
        class="mr-3"
        icon
        @click.prevent="deleteItem(item)"
      >
        <DeleteIcon style="width: 20px;height: 25px;" />
      </v-btn>
    </v-card-actions>
    <v-dialog
      v-model="folderSelectDialog"
      max-width="790"
      scrollable
    >
      <SelectFolder
        :change-folder-item="changeFolderItem"
        :current-folder-id="item.item.folderId"
        :folders="folders"
        :items="[item]"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import VClamp from 'vue-clamp'
import FolderIcon from "@/component/svg/FolderIcon";
import DeleteIcon from "@/component/svg/DeleteIcon";
import ListIcon from "@/component/svg/ListIcon";
import dayjs from "dayjs";
import SelectFolder from "@/component/SelectFolder";
import config from "@/const";
import DragHandle from "@/component/DragHandle";
import {mapState} from "vuex";
export default {
  name: "FolderCard",
  components: {
    VClamp,
    FolderIcon,
    DeleteIcon,
    ListIcon,
    SelectFolder,
    DragHandle
  },
  filters: {
    dayjs: function (date) {
      return dayjs(date).format('YYYY/MM/DD HH:mm');
    }
  },
  props: ["item", "accentColor", "backgroundColor", "deleteItem", "edit", "folders", "changeFolderItemParent", "toggleItemCheck", "checkedItems","originalSort"],
  data() {
    return {
      folderSelectDialog: false
    }
  },
  computed: {
    ...mapState({
      user: state => state.userModule.user,
    }),
  },
  mounted() {
  },
  methods: {
    encodeHash: function (id) {
      return config.HASH_IDS.encode(id)
    },
    changeFolderItem(toFolderId, items) {
      if (toFolderId != null)
        this.changeFolderItemParent(toFolderId, items)
      this.folderSelectDialog = false
    },
  }
}
</script>

<style scoped>

</style>